<template>
<div>
  <b-row v-if="cardType === 1">
      <b-col :cols="`${cols}`" :md="`${md}`" :lg="`${lg}`" v-for="result in result" :key="result.uniqueID">
        <b-card no-body class="f-card mb-4">
          <router-link :to="`/Video/${result.uniqueID}`" :title="`${result.name}`" class="link-overlay"  v-on:click="componentKey++"></router-link>
          <div class="position-relative f-card__image">
            <b-img
              :src="`${result.imageUrl}`"
              :alt="`${result.imageUrl}`"
            >
            </b-img>
            <b-card-body class="card-img-overlay">
              <b-card-text class="f-card__videolenght">
                {{ result.duration }}
              </b-card-text>
              <b-card-text  class="f-card__seriescount" v-if='result.seriesCount != "" && result.seriesCount != "1"'>
                {{ result.seriesCount }} Videos
              </b-card-text>
              <b-card-text  class="f-card__seriescount" v-else>
                {{ result.seriesCount }} Video
              </b-card-text>
              <b-card-text  class="f-card__sensitivecontent" v-if="result.sensitiveContent">
                Sensitive Content
              </b-card-text>
              <b-card-title class="f-card__category">
                {{ result.tags[0].tagName }}
              </b-card-title>
            </b-card-body>
          </div>
          <b-card-body class="f-card__body">
            <b-card-title class="f-card__title">
              {{ result.name }}
            </b-card-title>
            <b-card-text class="f-card__summary">
              {{ result.summary.substring(0,100) + '...' }}
            </b-card-text>
            <b-card-text v-if="portalName != 'Femalelead'" class="f-card__series-name">
              {{ result.seriesName }}
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12">
        <div v-show="pagination" class="fpagination text-center" :class="{'d-none': prevData === '' && nextData === ''}">
          <b-button size="sm" :class="{'disabled':prevData === ''}" class="mr-2" variant="primary" @click="previous">Previous</b-button>
          <b-button size="sm" :class="{'disabled':nextData === ''}" variant="primary" @click="next">Next</b-button>
        </div>
      </b-col>
  </b-row>
  <b-row v-if="cardType === 2 || cardType === 3">
    <b-col :cols="`${cols}`" :md="`${md}`" :lg="`${lg}`" v-for="result in result" :key="result.uniqueID">
      <b-card no-body class="f-card-champ-cinema mb-4 mt-4">
        <router-link :to="`/Video/${result.uniqueID}`" :title="`${result.name}`" class="link-overlay" v-on:click="componentKey++"></router-link>
        <div class="position-relative f-card-champ-cinema__image">
          <b-img :src="`${result.imageUrl}`" :alt="`${result.imageUrl}`">
          </b-img>
          <b-card-text class="f-card-champ-cinema__sensitivecontent" v-if="result.sensitiveContent">
            Sensitive Content
          </b-card-text>
          <b-card-text class="f-card-champ-cinema__seriescount" :class="'bg-' + result.tags[0].tagName.toLowerCase()" v-if='result.seriesCount != "" && result.seriesCount != "1"'>
            {{ result.seriesCount }} Videos
          </b-card-text>
          <b-card-text class="f-card-champ-cinema__seriescount" :class="'bg-' + result.tags[0].tagName.toLowerCase()" v-else>
            {{ result.seriesCount }} Video
          </b-card-text>
          <b-card-body class="f-card-champ-cinema__card-img-overlay">
            <b-card-title v-if="result.seriesLabel != null" class="f-card-champ-cinema__label mb-0">
              {{ result.seriesLabel.label }}
            </b-card-title>
            <b-card-title class="f-card-champ-cinema__category mb-0">
              {{ result.tags[0].tagName }}
            </b-card-title>
          </b-card-body>
          <b-card-body class="f-card-champ-cinema__body">
            <b-card-title class="f-card-champ-cinema__title">
              {{ result.name }}
            </b-card-title>
            <b-card-text class="f-card-champ-cinema__series-name float-left">
              {{ result.seriesName }}
            </b-card-text>
            <font-awesome-icon class="float-right h2" :class="'text-' + result.tags[0].tagName.toLowerCase()" :icon="['fas', 'play-circle']" />
          </b-card-body>
        </div>
      </b-card>
    </b-col>
      <b-col cols="12">
        <div v-show="pagination" class="fpagination text-center mb-4" :class="{'d-none': prevData === '' && nextData === ''}">
          <b-button size="sm" :class="{'disabled':prevData === ''}" class="mr-2" variant="primary" @click="previous">Previous</b-button>
          <b-button size="sm" :class="{'disabled':nextData === ''}" variant="primary" @click="next">Next</b-button>
        </div>
      </b-col>
  </b-row>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faPlayCircle)
export default {
  name: 'FrogVideoCard',
  props: {
    result: Array,
    title: String,
    portalName: String,
    imageUrl: String,
    tags: String,
    summary: String,
    uniqueID: Number,
    series: String,
    cols: Number,
    md: Number,
    lg: Number,
    pagination: Boolean,
    prevData: String,
    nextData: String,
    loading: Boolean,
    cardType: Number
  },
  methods: {
    next () {
      this.$emit('nextVideoPage')
    },
    previous () {
      this.$emit('previousVideoPage')
    }
  }
}
</script>
